import { cloneDeep, forEach } from 'lodash'

export default {
  getUniqueProductAttributeValueIdsAllProducts (state, getters) {
    const productAttributes = cloneDeep(getters.getProductAttributeInfoData)
    const uniqueProductAttributeValueIds = {}
    forEach(productAttributes, (attribute) => {
      uniqueProductAttributeValueIds[attribute.attribute_value_id] = true
    })
    return Object.keys(uniqueProductAttributeValueIds).map(key => parseInt(key))
  },
  getUsedAttributeValuesByGroupMerged (state, getters) {
    const uniqueAttrValueIds = getters.getUniqueProductAttributeValueIdsAllProducts

    const selectedFilters = state.allAttributes.filter(item => {
      return item.attributes.filter(sub => {
        return uniqueAttrValueIds.includes(sub.attributeId)
      }).length > 0
    })

    const relatedAttributeData = getters.getRelatedAttributeData

    const uniqueAttrValueIdsMerged = cloneDeep(uniqueAttrValueIds)
    forEach(relatedAttributeData, (product) => {
      forEach(Object.values(product.attributes), (value) => {
        uniqueAttrValueIdsMerged.push(value.attribute_value_id)
      })
    })

    return selectedFilters.map(item => {
      const attributes = item.attributes.filter(sub => {
        return uniqueAttrValueIdsMerged.includes(sub.attributeId)
      })

      const returnItem = JSON.parse(JSON.stringify(item))
      returnItem.attributes = attributes
      return returnItem
    })
  },
  attributeName: (state) => (attributeId) => {
    return state.allAttributes.reduce((acc, item) => {
      const attribute = item.attributes.find(sub => sub.attributeId === attributeId)
      if (attribute) {
        acc = attribute.attributeName
      }
      return acc
    }, '')
  },
  getRelatedAttributeData: state => state.relatedAttributeData,
  getAttributesActive: state => state.attributesActive,
  getListingAttributeGroupCombos: state => state.listingAttributeGroupCombos,
  getAttributeFilterQueryStringVar: state => state.attributeFilterQueryStringVar,
  getActiveAttributeFilters: state => state.activeAttributeFilters,
  getActiveAttributeFiltersString (state, getters) {
    if (getters.getActiveAttributeFilters.length <= 0) {
      return ''
    }
    return `${getters.getAttributeFilterQueryStringVar}[]=${getters.getActiveAttributeFilters.join(`&${getters.getAttributeFilterQueryStringVar}[]=`)}`
  },
  getActiveAttributeFiltersValueIds: (state) => {
    return state.activeAttributeFilters.map((id) => {
      const regex = /(\d+)/g
      const matches = id.match(regex)
      return Number(matches[0])
    })
  },
  getAttributeRecordsUsed: state => state.attributeRecordsUsed,
  getProductAttributeInfoData: state => state.productAttributeInfoData
}
